import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CATEGORIES } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useListingSearch } from "@/hooks/useListingSearch";
import { useFavorites } from "@/hooks/useFavorites";
import { FiltersPanel } from "@/components/category/FiltersPanel";
import { CategoryToolbar, ListingResults } from "@/components/category/CategoryParts";

export default function Category() {
  const { slug } = useParams();
  const { user } = useAuth();
  const { items, total, filters, applyFilters } = useListingSearch(slug);
  const { favs, toggle } = useFavorites(user);
  const [view, setView] = useState("grid");
  const [filtersOpen, setFiltersOpen] = useState(false);
  const name = CATEGORIES.find((c) => c.slug === slug)?.name || slug;

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 mt-6 md:mt-8" data-testid="category-page">
      <div className="flex items-center gap-2 font-mono-data text-xs uppercase mb-3">
        <Link to="/" className="link-blue">home</Link>
        <span>/</span>
        <span className="text-black font-bold">{name}</span>
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-end justify-between border-b-2 border-black pb-2">
        <h1 className="font-display text-3xl md:text-5xl uppercase">/ {name}</h1>
        <CategoryToolbar total={total} view={view} setView={setView} onToggleFilters={() => setFiltersOpen((o) => !o)} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-6">
        <FiltersPanel filters={filters} onChange={applyFilters} open={filtersOpen} />
        <main className="md:col-span-9" data-testid="listings-results">
          <ListingResults items={items} view={view} favs={favs} onToggleFavorite={toggle} />
        </main>
      </div>
    </div>
  );
}
